import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "How Turborepo is porting from Go to Rust",
  "description": "Our strategy for making updates and maintaining stability while we migrate languages.",
  "date": "2023/07/21",
  "isExternal": true,
  "href": "https://vercel.com/blog/how-turborepo-is-porting-from-go-to-rust"
};
export let structuredData = {
  "contents": [],
  "headings": [{
    "id": "external-entry",
    "content": "External Entry"
  }]
};
export const toc = [{
  depth: 1,
  url: "#external-entry",
  title: _jsx(_Fragment, {
    children: "External Entry"
  })
}];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    ...props.components
  };
  return _jsx(_components.h1, {
    id: "external-entry",
    children: "External Entry"
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
